import styled from '@emotion/styled';
import { fraudAndComplianceColors, mainColors } from 'src/assets/colors';
import {
    ChevronDownType,
    ChevronDownWrapperTemplate,
    ColumnHeaderTemplate,
    SectionMessageTemplate,
    TableCellTemplate,
    TableHeaderRowTemplate,
    TablePropsType,
    TableRowTemplate,
    TableSelectCellClickableTemplate,
    TableWrapperTemplate,
} from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';

export const SelfExcludedTabContainer = styled('div', { label: 'SelfExcludedTabContainer' })`
    flex: 1 1 0%;
    height: calc(100vh - 56px);
    overflow-y: auto;
    padding: 24px;
    font-size: 14px;
    line-height: 1.3;
    position: relative;
`;

export const PageHeader = styled('div', { label: 'PageHeader' })`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`;

export const Header = styled('h1', { label: 'Header' })`
    font-size: 24px;
    margin: 0;
`;

export const ErrorMessage = styled('div', { label: 'ErrorMessage' })`
    font-size: 14px;
    padding: 6px;
    margin-bottom: 16px;
    background-color: ${mainColors.status.ended};
    color: ${mainColors.status.error};
    border-radius: 4px;
`;

export const SectionWrapper = styled('div', { label: 'SectionWrapper' })``;

export const SectionHeader = styled('h2', { label: 'SectionHeader' })`
    font-size: 16px;
    color: ${fraudAndComplianceColors.withdrawalReqColors.txtColor};
    margin: 0 0 12px;
`;

export const SectionMessage = styled(SectionMessageTemplate, { label: 'SectionMessage' })`
    margin-top: 16px;
`;

export const TableWrapper = styled(TableWrapperTemplate, { label: 'TableWrapper' })``;

export const TableHeaderRow = styled(TableHeaderRowTemplate, { label: 'TableHeaderRow' })``;

export const TableRow = styled(TableRowTemplate, { label: 'TableRow' })<TablePropsType>`
    min-height: 50px;
`;

export const ColumnHeader = styled(ColumnHeaderTemplate, { label: 'ColumnHeader' })`
    :nth-of-type(1) {
        width: 35px;
    }
`;

export const TableCell = styled(TableCellTemplate, { label: 'TableCell' })`
    padding: 10px 8px;

    span {
        display: block;
    }
`;

export const ChevronDownWrapper = styled(ChevronDownWrapperTemplate, { label: 'ChevronDownWrapper' })<ChevronDownType>``;

export const TableSelectCellClickable = styled(TableSelectCellClickableTemplate, { label: 'TableSelectCellClickable' })`
    width: 35px;
`;

export const ExpandedAccountsCell = styled(TableCellTemplate, { label: 'ExpandedAccountsCell' })`
    padding: 10px 8px;
`;

export const ExpandedAccountsWrapper = styled('div', { label: 'ExpandedAccountsWrapper' })`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;
